import { Trans } from "@lingui/react/macro";
import { Button } from "@rakazo/ui-web";
import { Lock, Plus, Users } from "lucide-react";

export function BotCreatePicker({
  onCreateBot,
  onCreateGroup,
  onCreateSpace,
}: {
  onCreateBot: () => void;
  onCreateGroup: () => void;
  onCreateSpace: () => void;
}) {
  return (
    <div
      data-testid="bot-create-picker"
      className="flex w-[min(320px,calc(100vw-2rem))] flex-col p-1"
    >
      <Button
        variant="ghost"
        data-testid="create-new-bot"
        onClick={onCreateBot}
        className="min-h-11 w-full justify-start gap-3"
      >
        <Plus size={16} strokeWidth={1.8} aria-hidden="true" />
        <Trans>Create new Bot</Trans>
      </Button>
      <Button
        variant="ghost"
        data-testid="create-new-group"
        onClick={onCreateGroup}
        className="min-h-11 w-full justify-start gap-3"
      >
        <Users size={16} strokeWidth={1.8} aria-hidden="true" />
        <Trans>Create new Group</Trans>
      </Button>
      <Button
        variant="ghost"
        data-testid="create-new-space"
        onClick={onCreateSpace}
        className="min-h-11 w-full justify-start gap-3"
      >
        <Lock size={16} strokeWidth={1.8} aria-hidden="true" />
        <Trans>Create new Space</Trans>
      </Button>
    </div>
  );
}
